<script>
import AgentAccounts from "@/components/Agent/AgentAccounts.vue";
import MyAgent from "@/components/Agent/MyAgent.vue";
import PurchaseHistory from "@/components/Agent/PurchaseHistory.vue";
import AchievementTarget from "@/components/Agent/AchievementTarget.vue";
import AgentOrganization from "@/components/Agent/AgentOrganization.vue";
import AgentManageRange from "@/components/Agent/AgentManageRange.vue";

import {
  MapGender,
  MapRoles,
  MapAgentAuth,
  MapPaymentOperation
} from "@/common/util";
import cloneDeep from "lodash/cloneDeep";
import find from "lodash/find";
import moment from "moment";

export default {
  components: {
    AgentAccounts,
    MyAgent,
    PurchaseHistory,
    AchievementTarget,
    AgentOrganization,
    AgentManageRange
  },
  data() {
    const ROLE_SUPER_ADMIN =
      localStorage.getItem("roles").indexOf("ROLE_SUPER_ADMIN") > -1;
    const ROLE_REGION_MANAGER =
      localStorage.getItem("roles").indexOf("ROLE_REGION_MANAGER") > -1;
    const agentId = this.$route.params.agentId;
    return {
      ROLE_SUPER_ADMIN,
      ROLE_REGION_MANAGER,
      agentId,
      agentManage: false,
      agentInfo: {
        name: "",
        gender: "",
        phone: "",
        staffId: ""
      },
      ProvinceList: [],
      purchaseHistorList: [],
      purchaseHistorSourceData: {},
      editStation: false,
      agentAccountList: [],
      agentAccountSourceData: {},
      myAgentInfo:{},
      myAgentData:{},
      myAgentList:[],
      checkBoxSelect: true,
      editYearTarget: false,
      allProvince: false,
      rejectProvince: false,
      defaultValue: {},
      agentTargetList: [],
      agentOrganizationList: [],
      agentOrganizationSourceData: {},
      formInline: {
        provinceName: ""
      },
      tableData: [],
      tempTableData: [],
      tempArea: [],
      addingUser: false,
      addManageRange: false,
      addMyAgent: false,
      buttonArray: [
        {
          text: "编辑",
          key: "edit"
        }
      ],
      myAgentArr: [
        {
          label: "公司名称",
          keyName: "companyName",
          type: "text"
        },
        {
          label: "联系人姓名",
          keyName: "name",
          type: "text"
        },
        {
          label: "联系人性别",
          keyName: "gender",
          type: "radio",
          children: [
            {
              label: "男",
              keyName: "MALE"
            },
            {
              label: "女",
              keyName: "FEMALE"
            }
          ]
        },
        {
          label: "联系电话",
          keyName: "phone",
          type: "text"
        },
        {
          label: "疗程单价",
          keyName: "coursePrice",
          value: 1500,
          type: "price"
        },
      ],
      editAgentArray: [
        {
          label: "公司名称",
          keyName: "companyName",
          type: "text"
        },
        {
          label: "联系人姓名",
          keyName: "name",
          type: "text"
        },
        {
          label: "联系人性别",
          keyName: "gender",
          type: "radio",
          children: [
            {
              label: "男",
              keyName: "MALE"
            },
            {
              label: "女",
              keyName: "FEMALE"
            }
          ]
        },
        {
          label: "联系电话",
          keyName: "phone",
          type: "text"
        },
        {
          label: "疗程单价",
          keyName: "coursePrice",
          type: "price"
        },
      ],
      editAgentRangeArray: [
        {
          label: "联系人姓名",
          keyName: "name",
          type: "text",
          isDisable: true
        },
        {
          label: "所属省份",
          type: "select",
          keyName: "districtProvince",
          children: []
        },
        {
          label: "所属城市",
          keyName: "districtCity",
          type: "select",
          children: []
        }
      ],
      value1: true,
      textInputArray: [
        {
          label: "所属省市",
          keyName: "provinceName"
        }
      ],
      refreshComponentsStation: true,
      refreshComponentsAccount: true,
      refreshComponentsMyAgent: true,
      refreshPurchaseHistory: true
    };
  },
  created() {
    this.loadProvice();
    this.loadData();
    this.onLoadAgentStation();
  },
  methods: {
    async loadData() {
      if (this.agentId) {
        let data = await this.$http.getAgentInfoById(this.agentId);
        if (data) {
          const temp = {
            name: data.user.name,
            gender: MapGender(data.user.gender),
            phone: data.user.phone,
            userId: data.user.id,
            staffId: data.user.staffId,
            grade: data.grade,
            companyName: data.companyName,
            coursePrice: data.coursePrice,
            targetNumber: data.agentAchievement
              ? data.agentAchievement.targetNumber
              : "--",
            tempTargetNumber: data.agentAchievement
              ? data.agentAchievement.targetNumber
              : null,
            targetId: data.agentAchievement ? data.agentAchievement.id : null,
            remainingTreatmentCount: data.remainingTreatmentCount,
            singleSaleCount: data.singleSaleCount,
            finishScore:
              data.agentAchievement &&
              data.agentAchievement.actualNumber &&
              data.agentAchievement.targetNumber
                ? (
                    (data.agentAchievement.actualNumber /
                      data.agentAchievement.targetNumber) *
                    100
                  ).toFixed(2)
                : "0"
          };
          if (data.parent) {
            temp.parentId = data.parent.user.id;
            this.agentManage = data.parent.user.phone == localStorage.getItem("username");
          }
          this.agentInfo = temp;
        }
      }
    },
    async onEditAccount(form) {
      const stationId = this.$route.params.stationId;
      const updateData = {
        userId: this.agentId,
        // staffId: form.staffId,
        name: form.name,
        gender: form.gender,
        phone: form.phone,
        companyName: form.companyName,
        coursePrice: form.coursePrice
      };
      let result = await this.$http.regionEditAgent(updateData);
      if (result === "success") {
        this.loadData();
      }
    },
    async loadProvice() {
      if (this.ROLE_REGION_MANAGER) {
        let ProvinceList = await this.$http.getProvinceList("regionManager");
        let province = cloneDeep(this.editAgentRangeArray);
        if (ProvinceList.length > 0) {
          const provinceChildren = ProvinceList.map(o => {
            return {
              label: o.name,
              keyName: o.id,
              sons: o.sons,
              id: o.id,
              name: o.name
            };
          });
          province[1].children = provinceChildren;
          this.ProvinceList = provinceChildren;
          this.editAgentRangeArray = province;
        }
      }
    },
    async onLoadAgentRange() {
      let data = await this.$http.getAgentManageRangeByAgentId(this.agentId);
      if (data) {
        const cityIds = data.area.map(o => o.cityId);
        data.provinces.forEach(o => {
          let allPower = true;
          o.sons.forEach(item => {
            if (cityIds.indexOf(item.id) > -1) {
              item.hadPower = true;
            } else {
              allPower = false;
              item.hadPower = false;
            }
          });
          o.hadPower = allPower;
        });
        this.tableData = data.provinces;
        this.tempTableData = cloneDeep(data.provinces);
      }
    },
    async onLoadAgentStation(params) {
      let data = await this.$http.getAgentOrgnaizationsByAgentId(
        this.agentId,
        params
      );
      if (data && data.content) {
        let newTableData = [];
        data.content.forEach(item => {
          let sweekSalesales = [];
          if (item.weekSales && item.weekSales.length > 0) {
            item.weekSales.forEach((o, index) => {
              if (index + 1 === item.weekSales.length) {
                sweekSalesales.push(`${o.count} (今日)`);
              } else {
                sweekSalesales.push(`${o.count}`);
              }
            });
          }
          newTableData.push({
            name: item.name,
            stationId: item.stationId,
            district: item.district ? item.district.name : "--",
            id: item.stationUUID,
            lastMonth: item.lastMonthSales || 0,
            month: item.currentMonthSales || 0,
            sweekSalesales
          });
        });
        this.agentOrganizationList = newTableData;
        this.agentOrganizationSourceData = data;
        this.refreshComponentsStation = false;
        this.$nextTick(() => {
          this.refreshComponentsStation = true;
        });
      }
    },
    async onLoadAgentAccounts(params) {
      let data = await this.$http.getAgentAcountListByAgentId(
        this.agentId,
        params
      );
      if (data && data.content) {
        let newTableData = [];
        data.content.forEach(item => {
          newTableData.push({
            createdAt: moment(item.createdAt).format("YYYY-MM-DD"),
            gender: MapGender(item.gender),
            name: item.name,
            lastLoginAt: item.lastLoginAt
              ? moment(item.lastLoginAt).format("YYYY-MM-DD HH:mm:ss")
              : "尚未登录",
            phone: item.phone,
            id: item.userId,
            auths:
              item.auths && item.auths.length > 0
                ? item.auths.map(o => MapAgentAuth(o))
                : []
          });
        });
        this.agentAccountList = newTableData;
        this.agentAccountSourceData = data;
        this.refreshComponentsAccount = false;
        this.$nextTick(() => {
          this.refreshComponentsAccount = true;
        });
      }
    },
    async onLoadMyAgent(params) {
      if (!params) {
        params = {parentId: this.agentInfo.userId}
      } else {
        params.parentId = this.agentInfo.userId
      }
      
      let data = await this.$http.getAgentList(params, this.ROLE_SUPER_ADMIN ? "group" : "region");
      if (data && data.content) {
        let list = [];
        data.content.forEach(item => {
          list.push({
            companyName: item.companyName,
            name: item.user.name,
            id: item.user.id,
            gender: item.user.gender == 'MALE' ? '男' : (item.user.gender == 'FEMALE' ? '女' : '未知'),
            phone: item.user.phone
          })
        });
        this.myAgentList = list;
        this.myAgentData = data;
        this.refreshComponentsMyAgent = false;
        this.$nextTick(() => {
          this.refreshComponentsMyAgent = true;
        });
      }
    },
    async onSaveMyAgent(form) {
      const updateData = {
        name: form.name,
        phone: form.phone,
        gender: form.gender,
        companyName: form.companyName,
        coursePrice: form.coursePrice,
        parentId: this.agentInfo.userId,
        grade: 'SECONDARY' 
      };
      let result = await this.$http.AddNewAgent(updateData);
      if (result === "success") {
        this.onLoadMyAgent();
      }
    },
    async onLoadAgentTarget() {
      let data = await this.$http.getAgentAchievementHistoryByAgentId(
        this.agentId
      );
      if (data && data.content) {
        let newTableData = [];
        data.content.forEach(item => {
          console.log("item:")
          console.log(item)
          newTableData.push({
            createdAt: moment(item.createdAt).format("YYYY-MM-DD"),
            actualNumber: item.actualNumber,
            remark: item.remark,
            year: item.year,
            targetNumber: item.targetNumber,
            id: item.id,
            finishScore: `${(
              (item.actualNumber / item.targetNumber) *
              100
            ).toFixed(2)} %`,
            editRow: false,
            formValue: item.remark
          });
        });
        this.agentTargetList = newTableData;
      }
    },
    async onLoadAgentBuyHsitory(params) {
      if(!params) {
        params = {}
      }
      params.agentId = this.agentId;
      let data = await this.$http.findAgentPurchase(
        params
      );
      if (data && data.content) {
        let newTableData = [];
        data.content.forEach(item => {
          console.log("item:")
          console.log(item)
          newTableData.push({
            createdAt: moment(item.createdAt).format("YYYY-MM-DD"),
            operateType: item.operateType == 'REFUND' ? '退货' : '购买',
            operatorName: item.name,
            payment: item.payment,
            tempPayment: item.payment,
            remark: item.remark,
            unitPrice:
              item.recordType === "REFUND"
                ? `-¥${item.unitPrice * item.quantity}`
                : `¥${item.unitPrice * item.quantity}`,
            id: item.id,
            category: item.single ? "单次" : "疗程",
            quantity: item.recordType === "REFUND"? `-${item.quantity}` : item.quantity
          });
        });
        this.purchaseHistorList = newTableData;
        this.purchaseHistorSourceData = data;
        this.refreshPurchaseHistory = false;
        this.$nextTick(() => {
          this.refreshPurchaseHistory = true;
        });
      }
    },
    onSearch(val) {
      const provinceName = val.provinceName;
      let newTableData = [];
      this.tempTableData.forEach(item => {
        if (name.indexOf(provinceName) > -1) {
          newTableData.push(item);
        } else {
          let flag = false;
          item.sons.forEach(o => {
            if (o.name.indexOf(provinceName) > -1) {
              flag = true;
            }
          });
          if (flag) {
            newTableData.push(item);
          }
        }
      });
      this.tableData = newTableData;
    },
    async onAddRange(data) {
      const formData = {
        agentId: this.agentId,
        districtId: data.districtCity
      };
      const result = await this.$http.AddNewAgentManageRange(formData);
      if (result === "success") {
        this.onLoadAgentRange();
      }
    },
    onClickEditBeginLevel() {
      this.editYearTarget = true;
    },
    async EditBeginLevel(save) {
      if (save) {
        const formData = {
          agentAchievementId: this.agentInfo.targetId,
          targetNumber: this.agentInfo.tempTargetNumber
        };
        let data = await this.$http.regionUpdateAgentTarget(
          this.agentId,
          formData
        );
        if (data === "success") {
          this.$message.success("提交成功");
          this.agentInfo.targetNumber = this.agentInfo.tempTargetNumber;
          this.editYearTarget = false;
        } else {
          this.$message.warning("保存失败，请重试");
          this.agentInfo.tempTargetNumber = this.agentInfo.targetNumber;
          this.editYearTarget = false;
        }
      } else {
        this.agentInfo.tempTargetNumber = this.agentInfo.targetNumber;
        this.editYearTarget = false;
      }
    },
    onChangeProvincePower(row) {
      this.defaultValue = row;
      if (row.hadPower) {
        this.allProvince = true;
      } else {
        this.rejectProvince = true;
      }
    },
    onClickCancel(key) {
      this.defaultValue = {};
      switch (key) {
        case "allProvince":
          this.allProvince = false;
          break;
        case "rejectProvince":
          this.rejectProvince = false;
          break;
      }
    },
    async onChangeDistrict(formdata, type, row) {
      const updateData = {
        agentId: this.agentId
      };
      if (row.sons.length > 0) {
        let cityIds = row.sons.map(o => o.id);
        updateData.cityIds = cityIds;
        updateData.enabled = row.hadPower;
      }
      const result = await this.$http.regionEditAgentManageRange(updateData);
      if (result === "success") {
        this.onLoadAgentRange();
      } else {
        this.$message({
          showClose: true,
          message: result,
          type: "error",
          customClass: "handleCloseRangeFaildAlert"
        });
        row.hadPower = !row.hadPower;
      }
    },
    async onChangeCityPower(row) {
      const updateData = {
        agentId: this.agentId,
        cityIds: [row.id],
        enabled: row.hadPower
      };
      const result = await this.$http.regionEditAgentManageRange(updateData);
      if (result === "success") {
        this.$message.success("提交成功");
        this.tableData.forEach(o => {
          let allPower = true;
          let allReject = true;
          o.sons.forEach(item => {
            if (item.hadPower) {
              allReject = false;
            } else {
              allPower = false;
            }
          });
          o.allReject = allReject;
          o.hadPower = allPower;
        });
        const temp2 = this.tableData.filter(o => !o.allReject);
        if (temp2.length < this.tableData.length) {
          this.onLoadAgentRange();
        }
      } else {
        this.$message({
          showClose: true,
          message: result,
          type: "error",
          customClass: "handleCloseRangeFaildAlert"
        });
        row.hadPower = !row.hadPower;
      }
    },
    onSwitch(tabs) {
      if (tabs.label === "管理区域") {
        this.onLoadAgentRange();
      } else if (tabs.label === "医疗机构") {
        this.onLoadAgentStation();
      } else if (tabs.label === "已建账号") {
        this.onLoadAgentAccounts();
      } else if (tabs.label === "业绩目标") {
        this.onLoadAgentTarget();
      } else if (tabs.label === "购买历史") {
        this.onLoadAgentBuyHsitory();
      } else if (tabs.label === "分销商") {
        this.onLoadMyAgent();
      }
    },
    handleCurrentChange(type, params) {
      if (type === "purchaseHistorList") {
        this.onLoadAgentBuyHsitory(params);
      } else if (type === "agentOrganization") {
        this.onLoadAgentStation(params);
      } else if (type === "agentAccountList") {
        this.onLoadAgentAccounts(params);
      } else if (type === "myAgent") {
        this.onLoadMyAgent(params);
      }
    }
  }
};
</script>
<template>
  <div class="AgentDetailIndex">
    <el-card class="box-card" shadow="never">
      <div slot="header" class="clearfix">
        <span class="cardTitleText">基本信息</span>
        <DialogForm
          v-if="editStation"
          formTitle="编辑代理商"
          :formInputArray="editAgentArray"
          @close="editStation = false"
          @submitForm="onEditAccount"
          :defaultValue="agentInfo"
        />
        <textButtonGroup
          v-if="ROLE_REGION_MANAGER || agentManage"
          class="editButton"
          :buttonArray="buttonArray"
          @onOperationClick="editStation = true"
        />
      </div>
      <div class="agentDetile">
        <el-row :gutter="24">
          <el-col :span="6">
            <div class="grid-content bg-purple">公司名称: {{agentInfo.companyName}}</div>
          </el-col>

          <el-col :span="6">
            <div class="grid-content bg-purple">
              联系人: {{agentInfo.name}}
              <img
                v-if="agentInfo.gender === '女'"
                class="genderStyle"
                src="@/assets/female.png"
              />
              <img v-if="agentInfo.gender === '男'" class="genderStyle" src="@/assets/male.png" />
            </div>
          </el-col>
          <el-col :span="6">
            <div class="grid-content bg-purple">手机号: {{agentInfo.phone}}</div>
          </el-col>
          <el-col :span="6">
            <div class="grid-content bg-purple">疗程单价: {{agentInfo.coursePrice}}</div>
          </el-col>
        </el-row>
        <el-row :gutter="24" style="margin-top: -10px;">
          <el-col :span="6">
            <div class="grid-content bg-purple">剩余疗程/次数: {{agentInfo.remainingTreatmentCount}}/{{ agentInfo.singleSaleCount }}</div>
          </el-col>
          <el-col :span="6">
            <div v-if="ROLE_REGION_MANAGER" class="grid-content bg-purple">
              年度目标:
              <span
                v-if="editYearTarget === false"
                class="editLevelSpan"
                @click="editYearTarget = true"
              >
                {{agentInfo.tempTargetNumber}}
                <i class="el-icon-edit editIcon"></i>
              </span>
              <span v-else class="editRowLevel">
                <el-input-number
                  v-model="agentInfo.tempTargetNumber"
                  controls-position="right"
                  :min="1"
                  :max="1000000"
                  size="mini"
                  class="numberInput"
                ></el-input-number>
                <el-button
                  @click="EditBeginLevel(true)"
                  size="mini"
                  class="saveButton"
                  type="primary"
                >保存</el-button>
                <el-button @click="EditBeginLevel(false)" size="mini" class="cancelButton">取消</el-button>
              </span>
            </div>
            <div v-else class="grid-content bg-purple">年度目标:{{agentInfo.tempTargetNumber}}</div>
          </el-col>
          <el-col :span="6">
            <div class="grid-content bg-purple">
              目标完成度:{{agentInfo.finishScore}} %
              <div class="loadbar">
                <strong class="bar" :style="{height: `${agentInfo.finishScore}%`}" />
              </div>
            </div>
          </el-col>
          <el-col :span="6">
            <div class="grid-content bg-purple">
              代理商级别:{{agentInfo.grade == 'PRIMAL' ? '一级' : (agentInfo.grade == 'SECONDARY' ? '次级' : '未知')}} 
            </div>
          </el-col>
        </el-row>
      </div>
    </el-card>
    <el-tabs @tab-click="onSwitch" class="detailTab">
      <el-tab-pane label="医疗机构">
        <AgentOrganization
          :agentOrganizationList="agentOrganizationList"
          @handleCurrentChange="handleCurrentChange"
          :sourceData="agentOrganizationSourceData"
          v-if="refreshComponentsStation"
        />
      </el-tab-pane>
      <el-tab-pane label="管理区域">
        <DialogForm
          v-if="addManageRange"
          formTitle="添加管理范围"
          :formInputArray="editAgentRangeArray"
          @close="addManageRange = false"
          @submitForm="onAddRange"
          :defaultValue="agentInfo"
          :ProvinceList="ProvinceList"
        />
        <DialogForm
          v-if="allProvince"
          formTitle="请确认给全省的城市授权！"
          @close="onClickCancel"
          @submitForm="onChangeDistrict"
          keyOperation="allProvince"
          :defaultValue="defaultValue"
          confirmButton="确认"
        />
        <DialogForm
          v-if="rejectProvince"
          formTitle="请确认关闭全省城市的授权！"
          @close="onClickCancel"
          @submitForm="onChangeDistrict"
          keyOperation="rejectProvince"
          :defaultValue="defaultValue"
          confirmButton="确认"
        />
        <elementButton
          size="medium"
          v-if="ROLE_REGION_MANAGER || agentManage"
          @click="addManageRange = true"
          class="addRangeButton"
        >添加管理范围</elementButton>
        <searchForm
          class="searchForm"
          showSearch
          @onSearch="onSearch"
          :textInputArray="textInputArray"
        />
        <el-table
          :data="tableData"
          class="hospitalTable"
          :header-cell-style="{ 'padding-left': '5px',color: 'rgba(0,0,0,0.65)','font-size': '14px', 'background-color': '#fafafa !important'}"
          :cell-style="{'padding-left': '5px'}"
        >
          <el-table-column type="expand" width="50">
            <template slot-scope="scope" v-if="scope.row.sons.length > 0">
              <el-table
                :data="scope.row.sons"
                :key="scope.row.id"
                class="miniTable"
                :header-cell-style="{ 'padding-left': '5px',color: 'rgba(0,0,0,0.65)','font-size': '14px', 'background-color': '#fafafa !important'}"
                :cell-style="{'padding-left': '5px', 'background-color': '#fafafa !important'}"
              >
                <el-table-column width="100"></el-table-column>
                <el-table-column prop="name" align="left" label="城市名称" min-width="100"></el-table-column>
                <el-table-column min-width="150"></el-table-column>
                <el-table-column min-width="120"></el-table-column>
                <el-table-column label="状态" width="200">
                  <template slot-scope="scope">
                    <el-switch
                      v-if="ROLE_REGION_MANAGER"
                      v-model="scope.row.hadPower"
                      :scope="scope.row"
                      @change="onChangeCityPower(scope.row)"
                    ></el-switch>
                    <span v-if="scope.row.hadPower">已授权</span>
                    <span v-else>禁售</span>
                  </template>
                </el-table-column>
              </el-table>
            </template>
          </el-table-column>
          <el-table-column type="index" width="50"></el-table-column>
          <el-table-column prop="name" align="left" label="代理省市" min-width="100"></el-table-column>
          <el-table-column prop="regionName" align="left" label="所属大区" min-width="150"></el-table-column>
          <el-table-column prop="regionManager" align="left" label="大区经理" min-width="120"></el-table-column>
          <el-table-column prop="role" align="left" label="状态" width="200">
            <template slot-scope="scope">
              <el-switch
                v-if="ROLE_REGION_MANAGER"
                v-model="scope.row.hadPower"
                inactive-color="#18AE00"
                @change="onChangeProvincePower(scope.row)"
              ></el-switch>
              <span v-if="scope.row.hadPower">全部授权</span>
              <span v-else>部分授权</span>
            </template>
          </el-table-column>
        </el-table>
      </el-tab-pane>

      <el-tab-pane label="已建账号">
        <AgentAccounts
          :agentAccountList="agentAccountList"
          @handleCurrentChange="handleCurrentChange"
          :sourceData="agentAccountSourceData"
          v-if="refreshComponentsAccount"
        />
      </el-tab-pane>

      <el-tab-pane label="业绩目标">
        <AchievementTarget
          :agentTargetList="agentTargetList"
          @onLoadAgentTarget="onLoadAgentTarget"
        />
      </el-tab-pane>
      <el-tab-pane label="购买历史">
        <PurchaseHistory
          :purchaseHistorList="purchaseHistorList"
          @handleCurrentChange="handleCurrentChange"
          :sourceData="purchaseHistorSourceData"
          :agentId="agentId"
          v-if="refreshPurchaseHistory"
        />
      </el-tab-pane>
      <el-tab-pane label="分销商" v-if="agentInfo.grade == 'PRIMAL'">
        <DialogForm
          v-if="addMyAgent"
          formTitle="添加分销商"
          :formInputArray="myAgentArr"
          @close="addMyAgent = false"
          @submitForm="onSaveMyAgent"
          :defaultValue="myAgentInfo"
          :ProvinceList="ProvinceList"
        />
        <elementButton
          size="medium"
          v-if="ROLE_REGION_MANAGER"
          @click="addMyAgent = true"
          class="addRangeButton"
        >添加分销商</elementButton>
        <MyAgent
          :myAgentList="myAgentList"
          @handleCurrentChange="handleCurrentChange"
          :sourceData="myAgentData"
          v-if="refreshComponentsMyAgent"
        />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<style lang="scss">
@import "@/css/color.scss";

.AgentDetailIndex {
  background-color: #f5f6f7;
  .genderStyle {
    height: 17.5px;
    margin-bottom: -2px;
  }
  .editLevelSpan {
    cursor: pointer;
    min-width: 200px;
    .editIcon {
      margin-left: 5px;
      color: #00c1de;
    }
  }
  .editRowLevel {
    display: inline-block;
    .numberInput {
      min-width: 80px;
      .el-input__inner {
        padding-right: 12px;
        padding-left: 12px;
        width: 90px;
      }
    }
    .saveButton {
      background-color: #00c1de;
      border-color: #00c1de;
      color: #fff;
    }
    .cancelButton {
    }
  }
  .detailTab {
    background-color: #ffffff;
    .el-tabs__header {
      margin: auto;
      width: 97%;
    }
    .el-tabs__item {
      margin: 10px auto;
    }
    .el-tabs__content {
      min-height: 400px;
    }
  }
  .addRangeButton {
    margin: 10px 1.5%;
    width: 118px;
  }
  .loadbar {
    display: inline-block;
    width: 10px;
    height: 20px;
    background-color: #fff;
    border: 1px solid #ccc;
    position: relative;
    margin-bottom: -5px;
  }
  .bar {
    width: 100%;
    display: block;
    font-family: arial;
    font-size: 12px;
    background-color: #7ab7f8;
    position: absolute;
    bottom: 0;
  }

  .location {
    float: right;
  }

  .el-row {
    display: flex;
    &:last-child {
      margin-bottom: 0;
    }
  }
  .el-col {
    align-self: center;
    border-radius: 4px;
  }
  .bg-purple-dark {
    background: #99a9bf;
  }
  .bg-purple-light {
    background: #e5e9f2;
  }
  .grid-content {
    padding: 15px 20px;
    border-radius: 4px;
  }

  .agentDetile {
    font-size: 14px;
    // margin-bottom: 18px;
  }

  .clearfix:before,
  .clearfix:after {
    display: table;
    content: "";
  }
  .clearfix:after {
    clear: both;
  }
  .cardTitleText {
    font-size: 16px;
    font-weight: bold;
  }
  .box-card {
    margin-bottom: 20px;
  }
  .editButton {
    float: right;
  }

  .searchForm {
    float: right;
    height: 70px;
    margin-top: -10px;
  }
  .el-table th > .cell {
    font-weight: bold;
  }
  .hospitalTable {
    margin: 20px auto;
    border: 1px;
    width: 97%;
    .el-table th > .cell {
      font-weight: bold;
    }
    .el-table__body tr:hover > td {
      background-color: #e6f7ff !important;
      cursor: pointer;
    }

    .el-table__body tr.current-row > td {
      background-color: #e6f7ff !important;
      cursor: pointer;
    }

    .miniTable {
      width: 100%;
      background-color: #f5f6f7;
      .el-table th,
      .el-table td {
        padding: 0px;
      }
    }
    .el-table__expanded-cell[class*="cell"] {
      padding: 0px;
    }
  }
}
.handleCloseRangeFaildAlert {
  top: 85% !important;
  left: 85%;
}
</style>



// WEBPACK FOOTER //
// src/components/Agent/agentDetail.vue